import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {SubTitleMedium} from '@spaced-out/ui-design-system/lib/components/Text';

import {FormInput} from '../../lib/form-input';
import type {IInputItem} from '../../types/IInputItem';


type RequesterInformationFieldsProps = {
  formInputs: IInputItem[];
  disabledFields: {[fieldName: string]: boolean};
};

export const RequesterInformationFields = ({
  formInputs,
  disabledFields,
}: RequesterInformationFieldsProps) => {
  const {t} = useLabelTranslation();

  return (
    <>
      <SubTitleMedium>
        {t(
          'Please_answer_the_following_questions',
          'Please answer the following questions',
        )}
      </SubTitleMedium>
      {formInputs.map((item) => (
        <FormInput
          key={item.name}
          item={item}
          disabled={disabledFields[item.name]}
        />
      ))}
    </>
  );
};
